import { z } from 'zod';
import { idSchema } from './common.schemas';

/** entityId is text, not always a UUID — e.g. a login.blocked audit is keyed by email before a user row resolves. */
export const auditHistoryQuerySchema = z.object({
  entityType: idSchema,
  entityId: idSchema,
});
export type AuditHistoryQuery = z.infer<typeof auditHistoryQuerySchema>;
